<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-05 10:44:16
 * @Description: 数据总览模块 充电数据概览
 * @FilePath: \sheyang\src\module\overview\centerContent\overViewData.vue
-->
<template>
  <div class="overview-data">
    <div class="overview-total">
      <span class="label">累计运营收入</span>
      <div class="item-value">
        <span class="value">{{ overViewData.chargingFee | toFixed }}</span>
        <span class="unit">元</span>
      </div>
    </div>

    <div class="overview-middle-card">
      <div class="data-item">
        <span class="label">累计充电量</span>
        <div class="item-value">
          <span class="value">{{ overViewData.chargingAmount | toFixed }}</span>
          <span class="unit">kWh</span>
        </div>
      </div>
      <div class="data-item">
        <span class="label">今日充电量/昨日充电量</span>
        <div class="item-value">
          <span class="value">{{ overViewData.electricInternalTod | toFixed }}/{{ overViewData.electricInternalTodYesterday | toFixed }}</span>
          <span class="unit">kWh</span>
        </div>
      </div>
    </div>

    <div class="overview-small-card">
      <div class="data-item">
        <span class="label">累计光伏发电量</span>
        <div class="item-value">
          <!-- <span class="value">{{ overViewData.pvPowerGeneration | toFixed }}</span> -->
          <span class="value">122189</span>
          <span class="unit">kWh</span>
        </div>
      </div>
      <div class="data-item">
        <span class="label">今日光伏发电量</span>
        <div class="item-value">
          <span class="value">161</span>
          <span class="unit">kWh</span>
        </div>
      </div>
    </div>

    <div class="overview-small-card">
      <div class="data-item">
        <span class="label">累计储能供电量</span>
        <div class="item-value">
          <span class="value">9240</span>
          <span class="unit">kWh</span>
        </div>
      </div>
      <div class="data-item">
        <span class="label">今日储能供电量</span>
        <div class="item-value">
          <span class="value">0</span>
          <span class="unit">kWh</span>
        </div>
      </div>
    </div>

    <!-- <div class="total-card">
      <div class="total-item">
        <div class="item-label">
          累计充电量/金额
        </div>
        <div class="item-value">
          <span class="value">{{ overViewData.chargingAmount | toInt }}</span>
          <span class="unit">kWh</span>
          <span class="divide">/</span>
          <span class="value">{{ overViewData.chargingFee | toInt }}</span>
          <span class="unit">元</span>
        </div>
      </div>
      <div class="total-item">
        <div class="item-label">
          累计光伏发电量
        </div>
        <div class="item-value">
          <span class="value">{{ overViewData.pvPowerGeneration | toInt }}</span>
          <span class="unit">kWh</span>
        </div>
      </div>
    </div> -->
    <!-- <div class="other-card">
      <div class="data-item">
        <div class="value-row">
          <span class="value">
            {{ overViewData.chargingAmount | toInt }}
          </span>
          <span class="unit">kWh</span>
          <span class="divide">/</span>
          <span class="value">{{ overViewData.chargingFee | toInt }}</span>
          <span class="unit">元</span>
        </div>
        <div class="label">国网供电量/金额</div>
      </div>

      <div class="data-item">
        <div class="value-row">
          <span class="value">0</span>
          <span class="unit">kWh</span>
          <span class="divide">/</span>
          <span class="value">0</span>
          <span class="unit">元</span>
        </div>
        <div class="label">光伏供电量/金额</div>
      </div>

      <div class="data-item">
        <div class="value-row">
          <span class="value">0</span>
          <span class="unit">kWh</span>
          <span class="divide">/</span>
          <span class="value">0</span>
          <span class="unit">元</span>
        </div>
        <div class="label">储能供电量/金额</div>
      </div>

      <div class="data-item">
        <div class="value-row">
          <span class="value">{{ overViewData.chargeAmount | toInt }}</span>
          <span class="unit">次</span>
        </div>
        <div class="label">累计充电次数</div>
      </div>

      <div class="data-item">
        <div class="value-row">
          <span class="value">0</span>
          <span class="unit">kWh</span>
          <span class="divide">/</span>
          <span class="value">0</span>
          <span class="unit">元</span>
        </div>
        <div class="label">光伏充电量/金额</div>
      </div>

      <div class="data-item">
        <div class="value-row">
          <span class="value">0</span>
          <span class="unit">kWh</span>
          <span class="divide">/</span>
          <span class="value">0</span>
          <span class="unit">元</span>
        </div>
        <div class="label">光伏并网/并网金额</div>
      </div>

      <div class="data-item">
        <div class="value-row">
          <span class="value">0</span>
          <span class="unit">kWh</span>
          <span class="divide">/</span>
          <span class="value">0</span>
          <span class="unit">kWh</span>
        </div>
        <div class="label">光伏自用/存电</div>
      </div>

      <div class="data-item">
        <div class="value-row">
          <span class="value">0</span>
          <span class="unit">kWh</span>
          <span class="divide">/</span>
          <span class="value">0</span>
          <span class="unit">kWh</span>
        </div>
        <div class="label">储能充/放电量</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { toDecimal, formatNumber } from '@/utils';

const LIST_DATA = [
  {
    key: 'chargingAmount', name: '累计充电量', data: 0, unit: 'kWh', isMock: false,
  },
  {
    key: 'chargeAmount', name: '累计充电次数', data: 0, unit: '次', isMock: false,
  },
  {
    key: 'pvPowerGeneration', name: '累计光伏发电量', data: 0, unit: 'kWh', isMock: false,
  },
  {
    key: 'storedChargingAmount', name: '累计储能充电量', data: 0, unit: 'kWh', isMock: false,
  },
  {
    key: 'storedDisChargingAmount', name: '累计储能放电量', data: 0, unit: 'kWh', isMock: false,
  },
  {
    key: 'reduction', name: '累计减碳', data: 0, unit: '吨',
  },
];

export default {
  name: 'overViewData',
  props: {
    overViewData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    overViewData: {
      handler(val) {
        this.getValueByKey(val);
      },
      deep: true,
    },
  },
  data() {
    return {
      listData: [...LIST_DATA],
    };
  },
  filters: {
    // 取整 如果是string类型的数据，先转换成number类型，如果是 null 或者 undefined，返回0
    toInt(value) {
      if (typeof value === 'string' || typeof value === 'number') {
        return parseInt(value, 10);
      }
      if (value === null || value === undefined) {
        return 0;
      }
      return value;
    },
    toFixed (value) {
      // 不为空返回两位小数 string
      return value ? value.toFixed(0) : '0';
    },
    // 判断 如果数值大于 1000 则转换为 k 为单位的数值
    toK(value) {
      if (typeof value === 'string' || typeof value === 'number') {
        // 转换为数字类型
        const newValue = parseInt(value, 10);
        if (newValue > 1000) {
          return `${toDecimal(newValue / 1000, 1)}k`;
        }
      } else {
        return value;
      }
      return 0;
    },
  },
  methods: {
    // 根据对象的key值获取value值
    getValueByKey(obj) {
      const matchingData = LIST_DATA.map((item) => {
        if (item.isMock) {
          return item;
        }
        const value = obj[item.key];
        const cloneItem = { ...item };

        if (value > 1000 && cloneItem.unit === 'kWh') {
          cloneItem.data = toDecimal(value / 1000);
          if (item.key === 'chargingAmount') {
            cloneItem.data = toDecimal(value / 1000);
          }
          cloneItem.unit = 'MWh';
        } else if (cloneItem.unit === '吨') {
          cloneItem.data = formatNumber(value, '');
          // cloneItem.unit = '万吨';
        } else {
          cloneItem.data = toDecimal(value);
          if (item.key === 'chargeAmount') {
            // const total = toDecimal(value);
            // cloneItem.data = formatNumber(total, '');
            cloneItem.data = value;
          }
        }
        return cloneItem;
      });
      this.listData = [...matchingData];
    },
  },
};
</script>

<style lang="less" scoped>
.overview-data {
  padding: 0 40px;
  padding-top: 45px;
  .displayFlex(space-around);

  .overview-total {
    box-sizing: border-box;
    width: 230px;
    height: 160px;
    padding-top: 84px;
    padding-left: 30px;
    background-image: url('~@/assets/images/totalFeeBg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .label {
      margin-bottom: 8px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      text-shadow: 0px 1px 1px rgba(255,255,255,0.1);
    }
    .item-value {
      .value {
        font-size: 28px;
        font-family: DINAlternate, DINAlternate;
        font-weight: bold;
        color: #FFFFFF;
        text-shadow: 0px 1px 4px #42CAFF;
      }
      .unit {
        margin-left: 2px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #CCCCCC;
        text-shadow: 0px 0px 8px #00B2FF;
      }
    }
  }

  .overview-middle-card {
    box-sizing: border-box;
    width: 230px;
    height: 160px;
    padding-top: 25px;
    padding-left: 20px;
    background-image: url('~@/assets/images/newOverViewMiddleCard.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .data-item {
      &:first-child {
        margin-bottom: 20px;
      }
      .label {
        margin-bottom: 10px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        text-shadow: 0px 1px 1px rgba(255,255,255,0.1);
      }
      .item-value {
        .value {
          font-size: 20px;
          font-family: DINAlternate, DINAlternate;
          font-weight: bold;
          color: #FFFFFF;
          text-shadow: 0px 0px 8px #00B2FF;
        }
        .unit {
          margin-left: 2px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #CCCCCC;
          text-shadow: 0px 1px 1px rgba(255,255,255,0.1);
        }
      }
    }
  }

  .overview-small-card {
    box-sizing: border-box;
    width: 168px;
    height: 160px;
    padding-top: 25px;
    padding-left: 20px;
    background-image: url('~@/assets/images/newOverViewSmallCard.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .data-item {
      &:first-child {
        margin-bottom: 20px;
      }
      .label {
        margin-bottom: 10px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        text-shadow: 0px 1px 1px rgba(255,255,255,0.1);
      }
      .item-value {
        .value {
          font-size: 20px;
          font-family: DINAlternate, DINAlternate;
          font-weight: bold;
          color: #FFFFFF;
          text-shadow: 0px 0px 8px #00B2FF;
        }
        .unit {
          margin-left: 2px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #CCCCCC;
          text-shadow: 0px 1px 1px rgba(255,255,255,0.1);
        }
      }
    }
  }

  .total-card {
    width: 246px;
    height: 212px;
    box-sizing: border-box;
    padding-left: 40px;
    padding-top: 24px;
    background-image: url('~@/assets/images/overViewBigCard.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .total-item {
      margin-bottom: 30px;

      .item-label {
        margin-bottom: 11px;
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        text-shadow: 0px 0px 8px #1DBBFF;
      }
      .item-value {
        .value {
          font-size: 24px;
          font-family: DINAlternate, DINAlternate;
          font-weight: bold;
          color: #FFFFFF;
          text-shadow: 0px 0px 8px #00B2FF;
        }
        .unit {
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          text-shadow: 0px 0px 8px #00B2FF;
        }
        .divide {
          font-size: 26px;
          font-family: PingFangTC, PingFangTC;
          font-weight: 600;
          color: #FFFFFF;
          text-shadow: 0px 0px 8px #00B2FF;
        }
      }
    }
  }

  .other-card {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 10px;
    .data-item {
      box-sizing: border-box;
      width: 166px;
      height: 100px;
      padding-top: 20px;
      padding-left: 10px;
      position: relative;
      background-image: url('~@/assets/images/overViewNomalCard.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .value-row {
        margin-bottom: 12px;
        // 不换行超出部分隐藏
        white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        .value {
          font-size: 18px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: 400;
          color: #FFFFFF;
          text-shadow: 0px 0px 8px #00B2FF;
        }
        .divide {
          font-size: 24px;
          font-family: DINAlternate, DINAlternate;
          font-weight: 400;
          color: #FFFFFF;
          text-shadow: 0px 0px 8px #00B2FF;
        }
        .unit {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          text-shadow: 0px 0px 8px #00B2FF;
        }
      }
      .label {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        text-shadow: 0px 1px 4px #42CAFF;
      }
    }
  }
}
</style>
